<form [formGroup]="formDetalhe">
  <div class="row">
    <div class="form-group col-md-12">
      <label>Municipio</label>
      <input id="municipio" formControlName="municipio"  type="text" class="form-control" 
      [value]="formDetalhe.get('municipio').value">
    </div>
    <div class="form-group col-md-4">
      <label>Índice IPM</label>
      <input id="dtIni" formControlName="indiceIPM" type="numeric" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label>Mês Referência</label>
      <input id="dtFim" formControlName="mesReferencia" type="text" class="form-control">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-md-4">
      <label>Valor Distribuído</label>
      <input id="valorDistribuido" appCurrencyMask placeholder="R$ 0,00" inputmode="numeric" formControlName="valorDistribuido" type="text" class="form-control">
    </div>
    <div class="form-group col-md-4">
      <label>Valor Arredondado</label>
      <input id="valorArredondado" appCurrencyMask placeholder="R$ 0,00" inputmode="numeric" formControlName="valorArredondado" type="text" class="form-control">
    </div>
  </div>
</form>

<style>
  .aslib-grid-wrapper{
    margin-bottom: 0px !important;
  }
  .form-group {
    margin-bottom: 0.5rem !important;
  }
  </style>


// WEBPACK FOOTER //
// ./src/app/royalts/cadastra-valor-mensal/detalhe-valor-mensal/detalhe-valor-mensal.component.html